import React, { Component } from 'react'

import { Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn, TableFooter } from 'material-ui/Table';
import Pagination from 'react-js-pagination';
import FlatButton from 'material-ui/FlatButton';
import Dialog from 'material-ui/Dialog';
import Box from '../ui/Box';

import NewFoodItem from './NewFoodItem';

//providers
import DataService from '../../services/DataService'; var ds = DataService;
import LocalStorageService from '../../services/LocalStorageService'; var ls = LocalStorageService;

export default class FoodItemList extends Component {

  constructor(props) {
    super(props);
    this.state = {
      all_food: [],
      current_offset: 0,
      activePage: 1,
      totalCount: 0,
      maxItems: 20,
      isDemoLogin: false,
      dialog: {
        open: false,
        head: 'Dude',
        body: 'This is working',
        actions: [
          <FlatButton
            label="Okay"
            primary
            onClick={this.closeDialog.bind(this)}
          />
        ]
      }
    }
  }

  maxItems = 10;
  componentDidMount() {
    this.getAllFood(this.state.current_offset);
    window.addEventListener('updateFoodMenuTable', (e) => {
      if (e.detail && e.detail == true) {
        this.refreshTable();
      }
    });
  }

  refreshTable(e) {
    this.getAllFood(this.state.current_offset - this.maxItems > 0 ? this.state.current_offset - this.maxItems : 0, 1);
  }

  onChangePage(e) {
    this.getAllFood(this.maxItems * (e - 1));
    this.setState({
      activePage: e
    })
  }

  getAllFood(offset, offset_change = 0) {
    const userData = ls.getUserDetails();
    if (userData.is_demo_user) {
      this.setState({
        isDemoLogin: true
      });

    } else {
      this.setState({
        isDemoLogin: false
      });
    };

    ds.getFoodMenu(userData.hotel_id, 10, offset,
      data => {
        this.setState({
          all_food: data,
          totalCount: data.length
        });
        if (!offset_change) {
          let x = this.state.current_offset;
          this.setState({
            current_offset: offset + this.maxItems
          })
        }
      }, err => {}
    )
  }

  closeDialog(refresh = 0) {
    this.setState({
      dialog: {
        head: '',
        body: '',
        open: false,
        actions: []
      }
    })
    if (refresh) {
      this.getAllFood(0);
    }
  }

  editNumber(row, e) {
    this.setState({
      dialog: {
        open: true,
        body: <NewFoodItem details={row} unMountMe={this.closeDialog.bind(this)} />,
        actions: []
      }
    });
  }

  deleteNumber(row, e) {
    this.setState({
      dialog: {
        open: true,
        head: 'Delete',
        body: 'Delete Food Item permanently?',
        actions: [
          <FlatButton
            label="Delete"
            primary
            onClick={() => {
              ds.postDeleteFoodItem({ item_id: row._id, hotel_id: ls.getUserDetails().hotel_id },
                data => {
                  let x = this.state.current_offset - this.state.maxItems;
                  this.closeDialog();
                  this.getAllFood(x > 0 ? x : 0, 1);
                }, err => {}
              );
            }}
          />,
          <FlatButton
            label="Cancel"
            primary
            onClick={this.closeDialog.bind(this)}
          />
        ]
      }
    })
  }

  render() {
    let pagination;
    pagination = <Pagination
      activePage={this.state.activePage}
      itemsCountPerPage={this.maxItems}
      totalItemsCount={this.state.totalCount}
      pageRangeDisplayed={5}
      onChange={this.onChangePage.bind(this)} 
    />
    return (
      <div>
        <Box header='Restaurant Menu'>
          <Dialog
            title={this.state.dialog.head}
            actions={this.state.dialog.actions}
            modal={false}
            open={this.state.dialog.open}
            onRequestClose={this.closeDialog.bind(this)}
          >
            {this.state.dialog.body || 'NA'}
          </Dialog>
        
          <Table
            height={'45vh'}
            fixedHeader={true}
            fixedFooter={true}
            selectable={false}
            multiSelectable={false}
            bodyStyle={{ minWidth: 680, overflowX: 'auto' }}
          >
            <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
              <TableRow>
                <TableHeaderColumn tooltip="Name">Name</TableHeaderColumn>

                <TableHeaderColumn tooltip="Price">Price</TableHeaderColumn>

                <TableHeaderColumn tooltip="Price">Group(s)</TableHeaderColumn>

                <TableHeaderColumn tooltip="Options" style={{paddingLeft: '46px'}}>
                  Options
                </TableHeaderColumn>
              </TableRow>
            </TableHeader>

            <TableBody
              displayRowCheckbox={false}
              showRowHover={true}
              stripedRows={false}
            >
              {
                this.state.all_food.map((row, index) => (
                  <TableRow key={index}>
                    <TableRowColumn>{row.name}</TableRowColumn>
                    <TableRowColumn>{row.price}</TableRowColumn>

                    <TableRowColumn style={{paddingLeft: '0px', paddingRight: '0px'}}>
                      {
                        row.groups && row.groups.length ?
                          row.groups.map(i => {
                            return (
                              <li style={{ 
                                fontSize: '12px', fontWeight: '300', marginBottom: '0px', 
                              }}>
                                {i}
                              </li>
                            )
                          }) 
                        : 'None'
                      }
                    </TableRowColumn>
                    
                    <TableRowColumn style={{paddingLeft: '0px', paddingRight: '0px'}}>
                      <i className="material-icons link-fg"
                        style={{cursor:'pointer'}}
                        onClick={this.editNumber.bind(this, row)}
                      >
                        mode_edit
                      </i>

                      <i className="space"></i>

                      {
                        this.state.isDemoLogin === false ?
                          <i className="material-icons warn-fg"
                            style={{cursor:'pointer'}}
                            onClick={this.deleteNumber.bind(this, row)}
                          >
                            delete
                          </i>
                        : null
                      }
                    </TableRowColumn>
                  </TableRow>
                ))
              }
            </TableBody>

            <TableFooter></TableFooter>
          </Table>
        </Box>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./components/food/FoodItemList.js